var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifications-list"},_vm._l((_vm.notifications),function(notification,index){return _c('div',{key:index,staticClass:"notification-row"},[_c('notification-row',{attrs:{"notification":notification}}),_c('v-divider',{staticClass:"rows-divider"})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }